import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const LEVELS = [
  ["carburante", "Carburante", ["1/4", "1/2", "pieno"]],
  ["olio", "Olio lubrificante", ["min", "norm", "max"]],
  ["acqua", "Acqua radiatore", ["min", "norm", "max"]],
  ["tergivetro", "Liquido tergivetro", ["min", "norm", "max"]],
];
export const ZONES = { anteriore: "Anteriore", posteriore: "Posteriore", sinistro: "Lato sinistro", destro: "Lato destro", tetto: "Tetto" };

function Zone({ id, active, onToggle, ...rect }) {
  return (
    <rect {...rect} rx="6" data-testid={`damage-zone-${id}`} onClick={() => onToggle(id)}
      className="cursor-pointer transition-colors" fill={active ? "#FCA5A5" : "#F8FAFC"} stroke={active ? "#DC2626" : "#94A3B8"} strokeWidth="2" />
  );
}

function DamageDiagram({ danni, setDanni }) {
  const has = (z) => danni.some((d) => d.zona === z);
  const toggle = (z) => setDanni(has(z) ? danni.filter((d) => d.zona !== z) : [...danni, { zona: z, note: "" }]);
  const t = (x, y, s) => <text x={x} y={y} textAnchor="middle" fontSize="11" fill="#334155" pointerEvents="none">{s}</text>;
  return (
    <div className="space-y-2">
      <svg viewBox="0 0 320 210" className="w-full max-w-sm select-none" data-testid="damage-diagram">
        <Zone id="anteriore" active={has("anteriore")} onToggle={toggle} x="110" y="4" width="100" height="34" />
        <Zone id="sinistro" active={has("sinistro")} onToggle={toggle} x="60" y="44" width="46" height="120" />
        <Zone id="tetto" active={has("tetto")} onToggle={toggle} x="110" y="44" width="100" height="120" />
        <Zone id="destro" active={has("destro")} onToggle={toggle} x="214" y="44" width="46" height="120" />
        <Zone id="posteriore" active={has("posteriore")} onToggle={toggle} x="110" y="170" width="100" height="34" />
        {t(160, 25, "Anteriore")}{t(83, 108, "Sx")}{t(160, 108, "Tetto")}{t(237, 108, "Dx")}{t(160, 191, "Posteriore")}
      </svg>
      <p className="text-xs text-muted-foreground">Tocca le zone danneggiate (vista dall'alto, muso in alto).</p>
      {danni.map((d, i) => (
        <div key={d.zona} className="flex items-center gap-2">
          <span className="text-sm font-medium w-28 shrink-0 text-red-700">{ZONES[d.zona]}</span>
          <Input value={d.note} placeholder="Descrivi il danno" data-testid={`damage-note-${d.zona}`} className="h-8 text-sm"
            onChange={(e) => setDanni(danni.map((x, j) => (j === i ? { ...x, note: e.target.value } : x)))} />
        </div>
      ))}
    </div>
  );
}

export function MezzoFields({ km, setKm, livelli, setLivelli, danni, setDanni, annotazioni, setAnnotazioni }) {
  return (
    <div className="space-y-4" data-testid="mezzo-fields">
      <div className="rounded-lg border border-border p-3 space-y-3">
        <div className="flex items-center gap-3">
          <Label className="text-sm">Km</Label>
          <Input type="number" min="0" value={km} onChange={(e) => setKm(e.target.value)} data-testid="mezzo-km" className="h-8 w-36 text-sm" />
        </div>
        <p className="text-xs font-bold uppercase tracking-wide">Verifica livelli</p>
        {LEVELS.map(([k, label, opts]) => (
          <div key={k} className="flex flex-wrap items-center gap-2">
            <span className="text-sm w-36">{label}</span>
            {opts.map((o) => {
              const on = livelli[k] === o;
              const low = o === "1/4" || o === "min";
              return (
                <Button key={o} type="button" size="sm" data-testid={`level-${k}-${o.replace("/", "-")}`} variant={on ? "default" : "outline"}
                  onClick={() => setLivelli({ ...livelli, [k]: o })}
                  className={`h-8 rounded-full capitalize min-w-16 ${on ? (low ? "bg-orange-600 hover:bg-orange-700" : "bg-emerald-600 hover:bg-emerald-700") : ""}`}>{o}</Button>
              );
            })}
          </div>
        ))}
      </div>
      <div className="rounded-lg border border-border p-3 space-y-2">
        <p className="text-xs font-bold uppercase tracking-wide">Parti danneggiate (verifica pre uscita)</p>
        <DamageDiagram danni={danni} setDanni={setDanni} />
      </div>
      <div className="space-y-1">
        <Label>Annotazioni per mancanze o malfunzionamenti da comunicare al Responsabile Automezzi</Label>
        <Textarea value={annotazioni} onChange={(e) => setAnnotazioni(e.target.value)} data-testid="mezzo-annotazioni" rows={3} />
      </div>
    </div>
  );
}
